<div class="row p-3 my-3 mx-3">
    <div class="row">
        <div class="d-flex flex-column mb-4">
            <h1 class="sub-header-title">
                {{ this.selectedVerificationPackage ? 'Edit ' : 'Assign ' }} Verification Package
            </h1>
        </div>
    </div>
    <div class="mt-3">
        <form [formGroup]="form">
            <div class="row my-3">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Verification Package<span class="red">*</span></mat-label>
                        <input type="text"
                            placeholder="Select Verification Package"
                            matInput
                            [formControl]="verifPackageControl"
                            [matAutocomplete]="auto">
                            <mat-error *ngIf="verifPackageControl.invalid">
                                Please select a valid Verification Package
                            </mat-error>
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onVerifPackageSelectionChanged($event)" [displayWith]="displayVerifPackageFn">
                            <mat-option *ngFor="let verifPackage of filteredVerifPackages | async" [value]="verifPackage">
                                {{ verifPackage.id }} - {{ verifPackage.name }} - {{ verifPackage.description }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Price ($)</mat-label>
                        <input type="number" matInput placeholder="Enter Price" formControlName="price" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Currency<span class="required-input">*</span></mat-label>
                        <mat-select formControlName="currency_id">
                            <mat-option *ngFor="let currency of currencies" [value]="currency.id">
                                {{ currency.display_text }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <div class="mt-2 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="cancelAddVerificationPackage()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button"
            [disabled]="!canAssignVerificationPackage()" (click)="submitAssignVerificationPackage()">
            <mat-icon>check</mat-icon>
            Save Changes
        </button>
    </div>
</div>